import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KomunikatyTabeli, KomunikatyTabeliService } from '../../../@core/utils/komunikaty-tabeli.service';

import { SumowanieKwotService } from '../../../@core/utils/sumowanie-kwot.service';
import { Platnosc } from '../../../shared/models/platnosc.model';
import { ZakresDat } from '../../../shared/models/zakres-dat.model';

@Component({
  selector: 'ngx-platnosci-tabela',
  templateUrl: './platnosci-tabela.component.html',
  styleUrls: ['./platnosci-tabela.component.scss'],
})
export class PlatnosciTabelaComponent implements OnInit {

  _dane: Platnosc[];

  @Input()
  zakresDat: ZakresDat;

  @Input()
  showExportButtons: boolean = true;

  @Input()
  showFilters: boolean = true;

  @Input()
  hideSummary: boolean = false;

  temp = [];
  eksportKolumny = [];
  eksportPdfKolumnyStyle;
  wyswietlanieFiltrow = false;

  @Input() set dane(value: Platnosc[]) {
    if (value) {
      this.temp = [...value];
      this._dane = value;
    }
  }

  get dane(): Platnosc[] {
    return this._dane;
  }

  komunikatyTabeli: KomunikatyTabeli;

  constructor(
    private readonly komunikatyTabeliService: KomunikatyTabeliService,
    private readonly translate: TranslateService,
  ) { }

  ngOnInit() {
    this.odswiezKomunikatyTabeli();
    this.translate.onLangChange.subscribe(() => this.odswiezKomunikatyTabeli());

    this.odswiezKolumnyPdf();
    this.translate.onLangChange.subscribe(() => this.odswiezKolumnyPdf());
  }

  updateFilter(event, prop) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function (d) {
      return (d[prop] != null && d[prop].toString().toLowerCase().indexOf(val) !== -1) || !val;
    });
    this._dane = temp;
  }

  sumaKwota(value: number[]) {
    return new SumowanieKwotService().suma(value);
  }

  updateFilterMobile(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function(d) {
      return (d.faktura != null && d.faktura.toString().toLowerCase().indexOf(val) !== -1) || 
             (d.dataWystawienia != null && d.dataWystawienia.toString().toLowerCase().indexOf(val) !== -1) ||
             (d.terminPlatnosci != null && d.terminPlatnosci.toString().toLowerCase().indexOf(val) !== -1) ||
             !val;
    });
    this._dane = temp;
  }

  sumaKwot(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.kwota || 0), 0);
  }

  sumaKwotZaplaconych(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.kwotaZaplacona || 0), 0);
  }

  sumaKwotPozostalych(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.kwotaPozostala || 0), 0);
  }

  private odswiezKomunikatyTabeli() {
    this.komunikatyTabeli = this.komunikatyTabeliService.get();
  }

  private odswiezKolumnyPdf() {
    this.eksportKolumny = [
      {header: this.translate.instant('etykieta.lp'), dataKey: 'liczbaPorzadkowa'},
      {header: this.translate.instant('etykieta.faktura'), dataKey: 'faktura'},
      {header: this.translate.instant('etykieta.data-wystawienia'), dataKey: 'dataWystawienia'},
      {header: this.translate.instant('etykieta.termin-platnosci'), dataKey: 'terminPlatnosci'},
      {header: this.translate.instant('etykieta.kwota'), dataKey: 'kwota'},
      {header: this.translate.instant('etykieta.kwota-zaplacona'), dataKey: 'kwotaZaplacona'},
      {header: this.translate.instant('etykieta.kwota-pozostala'), dataKey: 'kwotaPozostala'},
    ];

    this.eksportPdfKolumnyStyle = {
      liczbaPorzadkowa: { halign: 'right' },
      kwota: { halign: 'right' },
      kwotaZaplacona: { halign: 'right' },
      kwotaPozostala: { halign: 'right' },
    };
  }
}
